import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface ProjectStagesServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<ProjectStagesServiceData>(db, 'projectStagesService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
